import { useState } from "react";
import { PORTFOLIO } from "../../lib/data";

const CATS = ["Alle", ...Array.from(new Set(PORTFOLIO.map((p) => p.cat)))];

export default function Portfolio() {
  const [active, setActive] = useState("Alle");
  const items = active === "Alle" ? PORTFOLIO : PORTFOLIO.filter((p) => p.cat === active);

  return (
    <section id="portfolio" data-testid="portfolio-section" className="py-24 md:py-32 bg-[#F8F5EF]">
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12 md:mb-16">
          <div className="md:col-span-7 reveal">
            <div className="flex items-center gap-3 mb-6">
              
              <span className="overline">Portfolio</span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] text-[#1A1A1A] tracking-tight">
              Ausgewählte <br />
              <span className="gold-text italic">Arbeiten</span>.
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 md:pt-12 md:flex md:items-end reveal">
            <p className="text-[15px] leading-relaxed text-[#5A5A5A] font-light">
              Ein Auszug aktueller Projekte für anspruchsvolle Kunden in NRW —
              von Penthouse bis Ferienwohnung.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap gap-3 mb-12 md:mb-16">
          {CATS.map((c) => (
            <button
              key={c}
              data-testid={`portfolio-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setActive(c)}
              className={`px-5 py-2.5 rounded-full text-xs uppercase tracking-[0.16em] transition-all duration-300 border ${
                active === c
                  ? "bg-[#1A1A1A] text-[#F8F5EF] border-[#1A1A1A] font-medium"
                  : "bg-transparent border-[#1A1A1A]/20 text-[#1A1A1A] hover:border-[#1A1A1A]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {/* Asymmetric / offset grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {items.map((p, i) => (
            <figure
              key={`${p.cat}-${i}`}
              data-testid={`portfolio-item-${i}`}
              className={`img-hover overflow-hidden reveal group relative ${
                i % 3 === 1 ? "lg:mt-16" : i % 3 === 2 ? "lg:mt-8" : ""
              }`}
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img src={p.img} alt={`${p.cat} – Wertbild`} className="w-full h-full object-cover" />
              </div>
              <figcaption className="flex items-center justify-between pt-4">
                <span className="overline text-[#1A1A1A]">{p.cat}</span>
                <span className="text-[10px] text-[#5A5A5A] uppercase tracking-[0.18em]">
                  {String(i + 1).padStart(2, "0")} · NRW
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
